<template>
    <application-modal v-model="noteModal">
        <v-btn
            data-testid="open-note-btn"
            class="open-note-btn indigo large white--text px-3"
            block
            slot="modal-trigger"
            @click.stop="openNoteModal"
        >
            <v-icon class="mr-2">add</v-icon>
            Add Note
        </v-btn>
        <div slot="modal-title">Add Note</div>
        <div slot="modal-body">
            <v-textarea
                data-testid="create-note-textarea"
                class="create-note-textarea"
                filled
                v-model="note"
                hint="When you are finished, select at least one unit and click 'Add Note' to save this note to the
                tenant's account."
                required
                :maxlength="descriptionMaxLength"
                counter
            />

            <v-select
                data-testid="payment-add-note-menu"
                class="payment-add-note-menu"
                v-show="customerUnits.length > 1"
                v-model="selectedUnits"
                :items="customerUnits"
                item-text="unitName"
                item-value="unitId"
                label="Add note to the following units..."
                filled
                multiple
                chips
                no-data-text="No additional units listed"
                color="green lighten-3"
            >
                <template v-slot:prepend-item>
                    <v-list-item
                        data-testid="check-all-units-checkbox"
                        class="check-all-units-checkbox"
                        ripple
                        @click="checkAllUnits"
                    >
                        <v-list-item-action>
                            <v-icon :color="selectedUnits.length === customerUnits.length ? 'green lighten-1' : ''">
                                {{checkboxIcon}}
                            </v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Select All Units</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </v-select>
        </div>

        <template slot="create-button">
            <v-layout wrap justify-end class="pa-0 ma-0">
                <div class="pa-0 ma-0">
                  <v-checkbox
                      data-testid="create-note-notify-manager-checkbox"
                      class="create-note-notify-manager-checkbox pr-4 mt-1 pt-1"
                      v-model="sendLedgerNote"
                      label="Notify Store Manager"
                      input-value="true"
                      hide-details
                      :disabled="!note"
                    />
                </div>
                <v-btn
                    data-testid="create-note-btn"
                    class="primary create-note-btn"
                    :disabled="!note || !selectedUnits.length"
                    :loading="loading"
                    @click="createNote"
                >Add Note</v-btn>
            </v-layout>

        </template>

    </application-modal>
</template>

<script>
import ApplicationModal from "@/components/ApplicationModal";

export default {
  name: "CreateNote",
  props: ["ledgerId", "ledgers"],
  data() {
    return {
      noteModal: false,
      loading: false,
      note: "",
      sendLedgerNote: false,
      selectedUnits: []
    };
  },
  methods: {
    openNoteModal() {
      this.noteModal = true;
      this.selectedUnits.push(this.customerUnits.find(unit => unit.unitId === this.ledgerId).unitId);
    },
    createNote() {
      this.loading = true;

      let payload = {
        facilityId: this.$route.params.facilityId,
        tenantId: this.$route.params.tenantId,
        ledgerId: "",
        description: this.note,
        notify_store_manager: this.sendLedgerNote
      };

      for (let i = 0; i < this.selectedUnits.length; i++) {
        payload.ledgerId = this.selectedUnits[i];
        this.$store.dispatch("createLedgerNote", payload)
          .then(resp => {
            this.$store.dispatch("handleSuccess", "Note successfully added to profile!");
            payload.ledgerId = "";
            this.note = "";
            this.selectedUnits = [];
            this.loading = false;
            this.noteModal = false;
            this.$emit("noteAdded");
          })
          .catch(err => {
            this.$store.dispatch("handleError", err);
            this.loading = false;
          });
      }
    },
    checkAllUnits() {
      this.$nextTick(() => {
        if (this.selectedAllUnits) {
          this.selectedUnits = [];
        } else {
          this.selectedUnits = this.filterCustomerUnitsId.slice();
        }
      });
    }
  },
  computed: {
    checkboxIcon() {
      if (this.selectedAllUnits) {
        return "check_box";
      } else if (this.selectedSomeUnits) {
        return "indeterminate_check_box";
      }
      return "check_box_outline_blank";
    },
    customerUnits() {
      return this.ledgers.map(units => {
        return { unitName: units.facility_unit.name, unitId: units.pms_ledger_id };
      });
    },
    filterCustomerUnitsId() {
      return this.ledgers.map(units => units.pms_ledger_id);
    },
    selectedAllUnits() {
      return this.selectedUnits.length === this.filterCustomerUnitsId.length;
    },
    selectedSomeUnits() {
      return this.selectedUnits.length > 0 && !this.selectedAllUnits;
    },
    descriptionMaxLength() {
      return this.sendLedgerNote ? 360 : 400;
    }
  },
  components: {
    ApplicationModal
  },
  watch: {
    descriptionMaxLength(value) {
      if (value === 360) {
        this.note = this.note.substring(0, value);
      }
    }
  }
};
</script>
